module.exports = __webpack_public_path__ + "media/flags/ru-fa3ca0b9.svg";